// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".select-container.fonts {\n  padding-right: 4px;\n  padding-top: 2px;\n  width: 160px;\n}\n.select-container.fonts button {\n  height: 32px !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
